import { createContext, useContext } from "react";
import { useShopApi } from "@/hooks/useShopApi";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const api = useShopApi();
  return <AuthContext.Provider value={api}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
